import {
  MotionBox as Box,
  MotionFlex as Flex,
  MotionContainer as Container,
  MotionGrid as Grid,
  staggeredAppear,
  appearBelow,
} from "utils/motion";
import Text from "components/base/Text";
import PostLink from "components/blog/PostLink";
import Trans from "components/base/Trans";

export default function BlogRelatedSection({ relatedArticles }) {
  if (!relatedArticles || relatedArticles.length <= 1) {
    return null;
  }

  return (
    <Box width="100%" bg="black.800" color="white">
      <Container
        maxWidth="xl"
        pt={[16, null, 24]}
        pb={[16, null, 24]}
        px={[6, null, 20]}
      >
        <Flex
          mb={[6, null, 10]}
          justifyContent="space-between"
          variants={appearBelow}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <Text type="title_lg" color="white">
            <Trans id="LBL_BLOG_RELATED" />
          </Text>
        </Flex>
        <Grid
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          width="100%"
          templateColumns={["1fr", null, "repeat(3, 1fr)"]}
          gap={6}
          mx={0}
        >
          {relatedArticles.map((relatedPost) => (
            <PostLink
              color="white"
              variants={appearBelow}
              key={relatedPost.article.uid}
              uid={relatedPost.article.uid}
              type={relatedPost.type}
              data={relatedPost.article.data}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
